var map = {
	"./home/tools/complete-bg.svg": "ubbU",
	"./home/tools/drive-bg.svg": "1AVU",
	"./home/tools/fundamentals-bg.svg": "Hdrm",
	"./home/tools/job-description-generator-bg.svg": "UIHE",
	"./home/tools/live-hr-advice-bg.svg": "Uk/y",
	"./home/tools/policy-manual-wizard-bg.svg": "xLGs",
	"./home/tools/surveys-bg.svg": "VHIW",
	"./home/tools/time-attendance-bg.svg": "ua2n",
	"./home/tools/training-bg.svg": "nH+4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cJkL";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\-bg\.svg$
// module id = cJkL
// module chunks = 0